import axios from "axios";

const CreateLessonAPI = async (token, data) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const params = `/admin/lesson/create?token=${token}`;
    const url = `${BASED_URL}${params}`;
    const res = await axios.post(url, data);
    return res.data;
  } catch (err) {
    return err.response;
  }
};

export default CreateLessonAPI;
